import styled from 'styled-components/native'

export const StyledMenuItem = styled.TouchableOpacity`
  align-items: center;
  flex-direction: row;
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 8px;
`
